module.exports = __webpack_public_path__ + "static/img/core-item-3.dfd213b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcessPhone/core-item-3.png
// module id = 181o
// module chunks = 0